const AUDIO_FILE_EXTENSIONS = ["mp3", "MP3", "wav", "WAV"];

export const isAudio = url => {
  if (!url) return false;
  const fileExtension = url.split(".").pop();
  if (
    AUDIO_FILE_EXTENSIONS.some(
      extension =>
        fileExtension && fileExtension.toLowerCase() === extension.toLowerCase()
    )
  ) {
    return true;
  }
  return false;
};
